import { requireRole } from '~/apps/shared/permissions';
import { UserRole } from '~/apps/shared/consts';

// Page imports
import OrgList from './pages/OrgList';
import OrgUserList from './pages/OrgUserList';
import OrgLocationList from './pages/OrgLocationList';
import OrgLocationEdit from './pages/OrgLocationEdit';


// Client-side routes
export const appRoutes = [
  {
    name: 'admin',
    path: '/admin',
    forwardTo: 'admin.orgs',
    canActivate: requireRole(UserRole.ADMIN),
    children: [
      {
        name: 'orgs',
        path: '/orgs',
        comp: OrgList,
        children: [
          {
            name: 'users',
            path: '/:orgId/users',
            comp: OrgUserList,
          },
          {
            name: 'locations',
            path: '/:orgId/locations',
            comp: OrgLocationList,
            children: [
              {
                name: 'edit',
                path: '/:locationId/edit',
                comp: OrgLocationEdit,
              }
            ]
          }
        ],
      },
    ]
  },
];
